import createReducer from '../utils/createReducer';
import inquiryActions from '../actions/inquiryModalActions';

const initialState = {};

const actionHandlers = {
    [inquiryActions.INQUIRY_APPLINK_SUCCESS](state, {payload}) {
        const {appLink: url} = payload;
        return {
            ...state,
            url
        };
    }
};

export default createReducer(actionHandlers, initialState);
